export default "__VITE_ASSET__aM_Zbaog__"